// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8U54u","total":"styles_total__UafP-","associated":"styles_associated__U1uNh","item":"styles_item__xmYzq","search":"styles_search__FUcOS"};